export const COOKIE_CONSENT = "idwal-cookie-preferences";

export function cookiePreferences(
    setCookie: (name: any, value: any, cookieOptions: any) => void,
    cookies?: { [key: string]: any }
) {
    const acceptAll = () => {
        const consentObject = {
            all: true,
            nonEssential: true,
            analytics: true
        };

        storePolicyCookie(consentObject);
    };

    const rejectAll = () => {
        const consentObject = {
            all: false,
            nonEssential: false,
            analytics: false
        };

        storePolicyCookie(consentObject);
    };

    const readCookiePreferences = () => {
        return cookies?.[COOKIE_CONSENT];
    };

    const acceptAnalytics = (accepted: boolean) => {
        const storedCookiePreferences = readCookiePreferences();

        if (!storedCookiePreferences) {
            const consentObject = {
                all: false,
                nonEssential: undefined,
                analytics: accepted
            };

            storePolicyCookie(consentObject);

            return;
        }

        const allAccepted =
            storedCookiePreferences?.nonEssential === true && accepted === true;

        const consentObject = {
            ...storedCookiePreferences,
            all: allAccepted,
            analytics: accepted
        };

        storePolicyCookie(consentObject);
    };

    const storePolicyCookie = (consentObject: any) => {
        const cookieOptions = {
            path: "/",
            domain: process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN
        };

        if (process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN === "localhost") {
            cookieOptions.domain = "localhost";
        }

        setCookie(COOKIE_CONSENT, JSON.stringify(consentObject), cookieOptions);
    };

    return {
        acceptAll,
        rejectAll,
        acceptAnalytics,
        readCookiePreferences,
        storePolicyCookie
    };
}
